import { seedsDarkTheme } from "../generated/compatibility";

// Preserve the named exports that existed on the authored dark theme module.
export var colors = seedsDarkTheme.colors;
export var shadows = seedsDarkTheme.shadows;
export default seedsDarkTheme;